import { Locale } from '../i18n'
import de from './de/translations.json'
import en from './en/translations.json'

export const locales: Locale = { de, en }
